import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from './index';

const YES_NO_ITEMS = [
  { id: 'Yes', label: 'Yes' },
  { id: 'No', label: 'No' },
];

const YesNoGroup = ({
  value, onChange, className, isHighlighted,
}) => (
  <RadioGroup
    items={YES_NO_ITEMS}
    defaultSelected={value}
    onChange={onChange}
    className={className}
    isHighlighted={isHighlighted}
  />
);

YesNoGroup.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  isHighlighted: PropTypes.bool,
};

YesNoGroup.defaultProps = {
  value: '',
  className: 'flex flex-row gap-8',
  isHighlighted: false,
};

export default YesNoGroup;
